import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": ".8",
      d: "M12.5 22.6c5.6 0 10.1-4.5 10.1-10.1S18.1 2.4 12.5 2.4 2.4 6.9 2.4 12.5s4.5 10.1 10.1 10.1z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": ".25",
      d: "M7.1 11.2H5.6v2.7h3.1v.1l-1.5.9v3.7h3.1V14h6.1v.1l-1.5.9v3.6H18V14h1.5v-2.7H18V6.5h-3.1v4.6h-4.6V6.5H7.1zm-1.5-.8h.8V6.5c0-.4.3-.7.7-.7h3.1c.4 0 .7.3.7.7v3.9h3.2V6.5c0-.4.3-.7.7-.7h3.1c.4 0 .7.3.7.7v3.9h.8c.4 0 .7.3.7.7v2.7c0 .4-.3.7-.7.7h-.8v3.9c0 .4-.3.7-.7.7h-3.1c-.4 0-.7-.3-.7-.7v-3.9h-3.2v3.9c0 .4-.3.7-.7.7H7.1c-.4 0-.7-.3-.7-.7v-3.9h-.8c-.4 0-.7-.3-.7-.7v-2.7c0-.3.3-.7.7-.7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "shop"}) } }